import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder,FormGroup,Validators,FormArray,AbstractControl,FormControl} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { EmailService } from 'src/app/modules/shared/services/email/email.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { ComponentReloadService } from 'src/app/modules/shared/services/reload/component-reload.service';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';

@Component({
  selector: 'app-email-pop-up',
  templateUrl: './email-pop-up.component.html',
  styleUrls: ['./email-pop-up.component.scss'],
})
export class EmailPopUpComponent implements OnInit {


  quotationForm!: FormGroup;
  selectedFileName: string = ''; // Stores uploaded file name
  response: any;
  @Input() emails: any;
  allFromEmails: any;
  @Input() itineraryDetails: any;
  @Input() totalNoOfNights: any;
  @Input() leadId: any;
  @Input() selectedDmcIds: any;
  @Input() selectedVendorIds: any;
  @Input() loadData: boolean = false;
  @Input() emaildata: any;
  fileErrorMessage: string = '';

  constructor(private fb: FormBuilder, private modalController: ModalController,
    private _globalService: GlobalService,
    private _emailService: EmailService,
    private _responseNotificationService: ResponseNotificationService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
  ) {

  }

  ngOnInit() {
    this.allFromEmails = this._globalService.retrieveOrganizationVerifiedEmails();
    let currentUser = localStorage.getItem('sub') || '';
    if (this._globalService.getUserSenderAccess() && this._globalService.getUserSenderAccess() === "SUCCESS") {
      this.allFromEmails.push(currentUser);
    }

    this.quotationForm = this.fb.group({
      fromEmail: [this.allFromEmails.at(-1) || '', [Validators.required, Validators.email]],
      toEmails: this.fb.array([], [this.minEmailsValidator(1)]),
      newEmail: [''], // Temporary field for adding new email
      subject: ['', Validators.required],
      notes: ['', Validators.required],
      isConfirmed: [false, Validators.requiredTrue],
      attachment: [null]
    });

    if (this.emails && this.emails.length) {
      const toEmailsArray = this.quotationForm.get('toEmails') as FormArray;
      this.emails.forEach((email: string) => {
        toEmailsArray.push(this.fb.control(email, [Validators.required, Validators.email, Validators.email,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
        Validators.maxLength(254)]));
      });
    }

  }

  // Getter for FormArray
  get toEmails(): FormArray {
    return this.quotationForm.get('toEmails') as FormArray;
  }

  // Custom Validator for minimum required emails
  minEmailsValidator(min: number) {
    return (formArray: AbstractControl) => {
      return (formArray as FormArray).length >= min ? null : { minEmails: true };
    };
  }

  // Add new email dynamically
  addEmail() {
    const newEmailValue = this.quotationForm.get('newEmail')?.value;
    if (newEmailValue && !this.toEmails.value.includes(newEmailValue)) {
      this.toEmails.push(this.fb.control(newEmailValue, [Validators.required, Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
      Validators.maxLength(254)]));
      this.quotationForm.get('newEmail')?.reset();
    }
  }

  // Remove an email, ensuring at least one remains
  removeEmail(index: number) {
    if (this.toEmails.length > 0) {
      this.toEmails.removeAt(index);
    }
  }

  onFileSelected(event: any) {
    this.selectedFileName = "";
    this.quotationForm.patchValue({
      attachment: null // Clear the attachment data
    });
    const file = event.target.files[0];

    if (file) {
      const maxSizeInMB = 2;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

      if (file.size > maxSizeInBytes) {
        this.fileErrorMessage = `File size exceeds ${maxSizeInMB}MB. Please upload a smaller file.`;
        return;
      } else
        this.fileErrorMessage = ''
    }
    this.selectedFileName = file.name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64File = reader.result?.toString().split(',')[1]; // Extract Base64
      this.quotationForm.patchValue({
        attachment: {
          fileName: file.name,
          fileType: file.type,
          fileData: base64File
        }
      });
    };
  }
  openAttachedFile() {
    const attachment = this.quotationForm.value.attachment;

    if (attachment && attachment.fileData) {
      const byteCharacters = atob(attachment.fileData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: attachment.fileType });
      const fileURL = URL.createObjectURL(blob);
      // this.modalController.dismiss();
      this._modalPopupService.openImageModal(fileURL);
    }
  }

  clearFile() {
    this.selectedFileName = "";
    this.quotationForm.patchValue({
      attachment: null // Clear the attachment data
    });

    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = ''; // Reset file input
    }
  }


  async sendQuotation() {

    var emaildata = {
      fromEmail: this.quotationForm.value.fromEmail,
      toEmails: this.quotationForm.value.toEmails,
      notes: this.quotationForm.value.notes,
      attachment: this.quotationForm.value.attachment,
      subject: this.quotationForm.value.subject
    };

    if (this.quotationForm.valid) {
      this._emailService.sendVendorDmc(emaildata).subscribe({
        next: async (data: any) => {
          this._responseNotificationService.showMessage("Email sent successfully!");
          this.response = data;
          await this._reloadService.triggerTravelPrefReload();
          await this._reloadService.triggerreloadVendorDmcsInPopup();
          this.modalController.dismiss({ submitted: true });
        },
        error: async (err: any) => {
          // Check if backend threw error but still sent the email
          const errorMessage = err?.error?.message || '';
          if (errorMessage.includes('Email sent')) {
            this._responseNotificationService.showMessage("Email sent (with server error). Please verify.");
            this.response = err.error;
            await this._reloadService.triggerTravelPrefReload();
            await this._reloadService.triggerreloadVendorDmcsInPopup();
            this.modalController.dismiss({ submitted: true });
          } else {
            this._responseNotificationService.showMessage("Failed to send email" , true);
            console.error("Error sending email:", err);
          }
        }
      });

    }

  }

  isFieldInvalid(field: string): boolean {
    const control = this.quotationForm.get(field);
    return control ? control.invalid && (control.touched || control.dirty) : false;
  }


  closeModal() {
    this.modalController.dismiss();
  }
}
